import { useSelector } from 'react-redux';
import { getRate } from '../selectors';

export const useGetRate = () => ({
  rate: useSelector(getRate),
});
